import { render, staticRenderFns } from "./QuestionContent.vue?vue&type=template&id=b6236a20&scoped=true"
import script from "./QuestionContent.vue?vue&type=script&lang=js"
export * from "./QuestionContent.vue?vue&type=script&lang=js"
import style0 from "./QuestionContent.vue?vue&type=style&index=0&id=b6236a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6236a20",
  null
  
)

export default component.exports